import { wrapper } from "../../redux";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import { fetchQuestions } from "../../redux/action-creaters/content";
import Faq from "/components/pages/faq";
import Redis from "/lib/redis";
import { Api } from "/api";
import pagesWrapper from "../../utils/pagesWrapper";

export default function FaqPage({ scripts, host, videos, isBaltex }) {
  return (
    <Faq scripts={scripts} host={host} videos={videos} isBaltex={isBaltex} />
  );
}

export const getServerSideProps = wrapper.getServerSideProps(function (store) {
  return async ({ req, query }) => {
    await store.dispatch(await fetchQuestions(Redis, Boolean(query.reset)));

    const videos = await Api.content.getPromoVideos(
      Redis,
      Boolean(query.reset),
    );

    store.dispatch(addBreadcrumb({ link: "/faq/", name: "Вопросы и ответы" }));

    return pagesWrapper(
      {
        videos,
      },
      store,
      Redis,
      {
        query,
        req,
      },
      "/faq/",
    );
  };
});
